import { render, staticRenderFns } from "./DatosSedeSubsede.vue?vue&type=template&id=1d5235b9&"
import script from "./DatosSedeSubsede.vue?vue&type=script&lang=js&"
export * from "./DatosSedeSubsede.vue?vue&type=script&lang=js&"
import style0 from "./DatosSedeSubsede.vue?vue&type=style&index=0&id=1d5235b9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports